import { FeatureCategory } from '../types';

export const chatCompanionsFeatures: FeatureCategory = {
  name: "Chat Companions & Support",
  icon: "Bot",
  features: [
    { 
      name: "Chat Companions", 
      description: "Access to all SeniorThrive chat companions: Finn for general support, Charlie for activities, Clarity for health guidance, Stanley for medication help, Riley for emotional support, and Luigi for culinary guidance.",
      starter: "✔", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Web & Mobile App Access", 
      description: "Full access to SeniorThrive across all devices including web browsers, tablets, and smartphones with synchronized data.",
      starter: "✔", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Live Agent Support", 
      description: "Access to live human support agents for technical assistance, platform guidance, and general help when needed.",
      starter: "✔", max: "✔", family: "✔", familyPlus: "✔", careAddOn: "✔"
    }
  ]
};
